module.exports = {
  baseURL: 'https://tgpapi.tutuchuguo.com',
  webURL: 'https://tgpapi.tutuchuguo.com',
}
